/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramReviewsUserControllerCreateMutationRequest,
  TelegramReviewsUserControllerCreateMutationResponse,
  TelegramReviewsUserControllerCreate401,
} from '../types/TelegramReviewsUserControllerCreate.ts';

function getTelegramReviewsUserCreateUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/reviews` as const };
  return res;
}

/**
 * {@link /api/user/telegram/reviews}
 */
export async function telegramReviewsUserCreate(
  data: TelegramReviewsUserControllerCreateMutationRequest,
  config: Partial<RequestConfig<TelegramReviewsUserControllerCreateMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramReviewsUserControllerCreateMutationResponse,
    ResponseErrorConfig<TelegramReviewsUserControllerCreate401>,
    TelegramReviewsUserControllerCreateMutationRequest
  >({ method: 'POST', url: getTelegramReviewsUserCreateUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
